import React from 'react';
import { Button } from 'reactstrap';
import { CloseableModal } from '../../../../../../components/CloseableModal';
import { useResolveApplicationEmailTemplate } from '../../../../../../mutations/v1/applicant_tracking/emailTemplates/useResolveApplicationEmailTemplate';
import styles from './styles.module.scss';
import { SafeHtml } from '../../../../../../components/SafeHtml';

interface EmailPreviewModalProps {
  isOpen: boolean;
  emailTemplateId: number;
  applicationId: number;
  onClose: () => void;
  onCancel: () => void;
}
export const EmailPreviewModal = ({
  isOpen,
  emailTemplateId,
  applicationId,
  onClose,
  onCancel,
}: EmailPreviewModalProps) => {
  const { data, isLoading } = useResolveApplicationEmailTemplate(
    emailTemplateId,
    applicationId,
    isOpen,
  );

  if (!isOpen || isLoading) return null;

  return (
    <CloseableModal
      headerTitle='Preview Email'
      bodyClassName={styles['preview-email-modal']}
      bodyChildren={
        <div className='bg-gray p-3 rounded-4 border'>
          <SafeHtml
            className='rounded-4 ms-10 me-10 p-3 bg-white'
            content={data.templateHtml}
          />
        </div>
      }
      footerClassName='modal-footer-shadow'
      footerChildren={
        <div className='d-flex gap-3 mt-2'>
          <Button color='danger' className='btn' onClick={onCancel}>
            Cancel Email
          </Button>
          <Button color='secondary' className='btn' onClick={onClose}>
            Close
          </Button>
        </div>
      }
      onClose={onClose}
      isOpen={isOpen}
      size='lg'
    />
  );
};
